import { gql } from '@apollo/client'

import { rowsViewFragment } from 'js/page/Page/rowsFragment'
import { pageViewSiteFragment } from 'js/page/PageViewSite.fragment'

export const GET_TOP_MENU_AND_FOOTER = gql`
    query TopMenu {
        site {
            guid
            logo
            logoAlt
            icon
            iconAlt
            showIcon
            showPreheader
            menuState
            menu {
                label
                localLabel
                link
                children {
                    label
                    localLabel
                    link
                    children {
                        label
                        localLabel
                        link
                    }
                }
            }
            blockedUserIntroMessage
            footer {
                title
                link
            }
            chatEnabled
            contentModerationEnabled
            requireContentModerationFor
            commentModerationEnabled
            requireCommentModerationFor
            footerPageEnabled
            footerRows {
                ${rowsViewFragment}
            }
            ...PageViewSiteFragment
        }
        viewer {
            guid
            loggedIn
            isAdmin
            isSubEditor
            isBanned
            isAutoBan
            banReason
            updateAccountUrl
            showSuspendAdminPrivilegesToggle
            isSuspendAdminPrivileges
            user {
                guid
                username
                name
                icon
                isChatUsersNotificationPushEnabled
                isChatGroupNotificationPushEnabled
                isOnline
                onlineStatus
                onlineStatusUpdatedAt
            }
            canAccessAdmin(permission: accessAdmin)
        }
    }
    ${pageViewSiteFragment}
`
